<div class="time-range-pill" role="group">
    @for (range of ranges(); track range.id) {
    <button
        type="button"
        class="time-range-pill__item"
        [class.is-selected]="selected() === range.id"
        [attr.aria-pressed]="selected() === range.id"
        (click)="pick(range.id)"
    >
        {{ range.label }}
    </button>
    }
</div>
